module.exports = __webpack_public_path__ + "img/case-gover_affairs.c9d6e597.png";